import React from 'react';
import { useTranslate } from 'react-redux-multilingual/lib/context';

import DashboardButton from './components/DashboardButton';
import LogoButton from './components/LogoButton';
import LogoutButton from './components/LogoutButton';

const ArticleAppBarItems = () => {
  const t = useTranslate();
  const logoButton = <LogoButton href='/sarparast' type='سرپرست' />;
  const logoutButton = <LogoutButton />
  const dashboardButton = <DashboardButton to='/create_account' name='ایجاد کاربر جدید' />

  return {
    desktopLeftItems: [dashboardButton, logoutButton],
    desktopRightItems: [logoButton],
    mobileLeftItems: [logoutButton],
    mobileRightItems: [logoButton],
    mobileMenuListItems: [dashboardButton, logoutButton],
  };
};

export default ArticleAppBarItems;
